import createAndAttachStyleSheet from 'onyx-common/createAndAttachStyleSheet'

const injectJss = (styles, opts) => {
  const sheet = createAndAttachStyleSheet(styles, opts)

  return sheet.classes
}

export default injectJss
